import {
  createRouter,
  createWebHistory,
  Router,
  RouteRecordRaw,
} from 'vue-router';

import Home from '@/views/Home/index.vue';
import { useHostConfigStore } from '@/store/hostConfigStore';

import Axios from 'axios';
import qs from 'qs';
import { ElMessage } from 'element-plus';
import { loginUrl } from '@/utils/axios';

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   name: 'Index',
  //   component: Index
  // },
  // {
  //   path: '/',
  //   redirect: {
  //     path: '/car',
  //   },
  // },
  // {
  //   path: '/carlist',
  //   redirect: {
  //     path: '/car',
  //   },
  // },
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
];

const router: Router = createRouter({
  history: createWebHistory('/'),
  routes,
});


router.beforeEach((to, from, next) => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state =urlParams.get('state');
  const localToken = localStorage.getItem('access_token');

  if (code) {
    if (localToken) {
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('access_token');
    }

    // 说明是登录以后跳转过来的
    Axios.post<
      any,
      {
        data: {
          access_token: string;
          refresh_token: string;
          user_name: string;
        };
      }
    >(
      `${useHostConfigStore().host_config.VITE_AUTH_HOST}/oauth/token`,
      qs.stringify({
        client_id: import.meta.env.VITE_CLIENT_ID,
        code,
        grant_type: 'authorization_code',
        client_secret: import.meta.env.VITE_CLIENT_SECRET,
        redirect_uri: useHostConfigStore().host_config.VITE_LOGIN_REDIRECT,
      }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
      .then((response) => {
        const { access_token, refresh_token, user_name } = response.data;

        if (access_token && refresh_token && user_name) {
          
          localStorage.setItem('access_token', access_token);
          localStorage.setItem('refresh_token', refresh_token);

          localStorage.setItem(
            'account',
            JSON.stringify({ displayName: user_name }),
          );

          if (state) {
            window.location.href = atob(state as string);
            return;
          }
        }
      })
      .catch(() => {
        ElMessage.error('登录失败，联系管理员');
      })
      .finally(() => {
      });
  } else if (!localToken) {
    const addr = btoa(window.location.href);

    localStorage.removeItem('refresh_token');
    localStorage.removeItem('access_token');

    const a = `${loginUrl()}&state=${addr}`;
    window.location.href = a;

  } else {
    next(); 
  }
});


export default router;
